import { render, staticRenderFns } from "./CardItems.vue?vue&type=template&id=498ecd4c&"
import script from "./CardItems.vue?vue&type=script&lang=js&"
export * from "./CardItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports